import UseCasesSection from '../UseCasesSection';
import AIIntegration from '../AIIntegration';

const PortfolioPage = () => (
    <div className="page-content">
        <UseCasesSection />
        <AIIntegration title='Connect your data from your tools and SaaS platforms' description='Seamlessly integrate data from various sources, including SaaS applications, databases, and APIs, to create a unified view of your business.' />
    </div>
);

export default PortfolioPage;
